import React, { FC } from 'react';
import styles from './entity_list_components.module.scss';

export const EntityListItem: FC = ({ children }) => (
  <div className={styles.item}>{children}</div>
);

export const EntityListIcon: FC<{ src: string; alt: string }> = ({
  src,
  alt,
}) => <img className={styles.icon} src={src} alt={alt} />;

export const EntityListGroup: FC = ({ children }) => (
  <div className={styles.group}>{children}</div>
);

export const EntityListSubtitleBlock: FC = ({ children }) => (
  <span className={styles.subtitleBlock}>{children}</span>
);
